import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthenticationComponent } from './authentication.component';
import { AuthenticationServiceImpl } from './authentication-service-impl.service';

@NgModule({
  declarations: [AuthenticationComponent],
  imports: [],
  exports: [AuthenticationComponent],
})
export class AuthenticationModuleImpl {
  public static forRoot(
    oauthApiUrl: string,
    openIdUrl: string,
    oauthClientId: string,
    oauthScopes: string,
    oauthRedirectUrl: string
  ): ModuleWithProviders<AuthenticationModuleImpl> {
    return {
      ngModule: AuthenticationModuleImpl,
      providers: [
        AuthenticationServiceImpl,
        AuthenticationComponent,
        { provide: 'oauthApiUrl', useValue: oauthApiUrl },
        { provide: 'openIdUrl', useValue: openIdUrl },
        { provide: 'oauthClientId', useValue: oauthClientId },
        { provide: 'oauthScopes', useValue: oauthScopes },
        { provide: 'oauthRedirectUrl', useValue: oauthRedirectUrl },
      ],
    };
  }
}
